import { ApiEntity} from "../../Api/api.model";
import { string, type, number, boolean,nullable} from "superstruct";
import { validateStruct } from "../../../utils/validate";
import { MediaAsset, MediaAssetStruct } from "../../../utils/assets";
import { extractLocker } from "../../serviceUtils";

export interface Achievement {
  id: string,
  name: string,
  title: string,
  description: string,
  bonus: number,
  lock: {
    locked:boolean;
    lockerId?:string;
  },
  coverImg: MediaAsset,
}


const AchievemetStruct = type({
  id: string(),
  name: string(),
  title: string(),
  description: string(),
  bonus: number(),
  lock: type({
    locked:boolean(),
    lockerId:nullable(string())
  }),
  coverImg: MediaAssetStruct,
});
export class AchievementEntity extends ApiEntity<Array<Achievement>> {
  constructor() {
    super('achievements');
  }
  validate(rawData: Array<{}>): Array<Achievement> {
    return rawData.map((rawItem) =>
      validateStruct<Achievement>(rawItem, AchievemetStruct,this.endPoint, [
        { field: "id", transform: (id: number) => id.toString() },
        { field: "lock", transform: extractLocker},{field:'id',transform:(id:number) => id.toString() }
      ])
    );
  }
}
